<template>
  <Modal v-model="orderImportTemplateModal" :title="orderImportTemplateTitle" width="900" :transfer="false"
    :mask-closable="false" class-name="orderImportTemplateStyle" @on-visible-change="orderImportTemplateChange">
    <Row style="width: 80%;">
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="mb10">
        <div class="flex align-items-center">
          <span>{{ $t('key1001207') }}</span>
          <Input style="width: 300px;" maxlength="16" v-model.trim="name" :placeholder="$t('key1000781')"/>
        </div>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="mb10">
        <div class="flex align-items-center">
          <span>{{ $t('key1006393') }}</span>
          <RadioGroup v-model="importType">
            <Radio v-for="item in importTypeList" :label="item.value">{{item.title}}</Radio>
          </RadioGroup>
        </div>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="mb10">
        <div class="flex align-items-center">
          <span>IOSS：</span>
          <RadioGroup v-model="iossType">
            <Radio v-for="item in iossTypeList" :label="item.value">{{item.title}}</Radio>
          </RadioGroup>
        </div>
      </Col>
    </Row>
    <h2 class="mt6 mb6 color-333 font-weight-bold font-size-15">{{ $t('key1006394') }}</h2>
    <div class="table-box mb15">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="420"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
        <template #excelTitle="{row, index}">
          <div class="flex align-items-center">
            <Input v-model.trim="tableData[index].excelTitle" :placeholder="$t('key1000324')"/>
            <Tooltip max-width="600" placement="top" class="ml5 cursor" transfer v-if="row.columnKey === 'YMSSKU' && importType === 2">
              <template #content>
                {{ $t('key1006395') }}<br/>
                {{ $t('key1006396') }}<br/>
                {{ $t('key1006397') }} {{ $t('key1006398') }}<br/>
                {{ $t('key1006399') }}<br/>
                {{ $t('key1006400') }}"{{ $t('key1006401') }}
              </template>
              <Icon type="md-alert" color="#FD5425" size="24"/>
            </Tooltip>
          </div>
        </template>
      </Table>
    </div>
    <Row style="width: 80%;">
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="mb10">
        <div class="flex align-items-center">
          <span>{{ $t('key1006402') }}</span>
          <RadioGroup v-model="sameOrderProcessing">
            <Radio :label="1">{{ $t('key1006403') }}</Radio>
            <Radio :label="2">{{ $t('key1006404') }}</Radio>
          </RadioGroup>
        </div>
      </Col>
      <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="mb10">
        <div class="flex align-items-center">
          <span>{{ $t('key1006405') }}</span>
          <RadioGroup v-model="fileSameOrderProcessing">
            <Radio :label="1">{{ $t('key1006406') }}</Radio>
            <Radio :label="2">{{ $t('key1006404') }}</Radio>
          </RadioGroup>
        </div>
      </Col>
    </Row>
    <template #footer>
      <Button @click="orderImportTemplateModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="orderImportTemplateBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, setConfigCharacters, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: 'orderImportTemplateModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      orderImportTemplateModal: false,
      orderImportTemplateTitle: '',
      orderImportTemplateType: null,
      name: '',
      importType: 1,
      iossType: 1,
      sameOrderProcessing: 1,
      fileSameOrderProcessing: 1,
      tableColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004432')}`,
          key: 'columnName',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006388'),
          key: 'contentNature',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let contentType = params.row.contentType;
            let text = getEnumName(v.enumData, 'YmsPackageInfoImportTempMappingContentTypeDistributorEnum', contentType, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006389'),
          key: 'handlingMethod',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006390'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006391'),
          key: 'excelTitle',
          minWidth: 350,
          align: 'center',
          slot: 'excelTitle'
        },
      ],
      tableData: [],
      originalData: [
        {columnKey: "orderShippingId", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006383'), contentType: 1, excelTitle: ''},
        {columnKey: "YMSSKU", columnName: `${setConfigCharacters(false)}SKU`, contentType: 1, excelTitle: ''},
        {columnKey: "warehouseName", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001606'), contentType: 1, excelTitle: ''},
        {columnKey: "quantity", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerCountry", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006384'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerState", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerCity", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), contentType: 1, excelTitle: ''},
        {columnKey: "district", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerAddress1", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002859'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerPostalCode", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), contentType: 0, excelTitle: ''},
        {columnKey: "buyerName", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006385'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerMobile", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), contentType: 1, excelTitle: ''},
        {columnKey: "buyerEmail", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006386'), contentType: 0, excelTitle: ''},
        {columnKey: "LogisticsChannelName", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000408'), contentType: 1, excelTitle: ''},
        {columnKey: "iossNo", columnName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006387'), contentType: 0, excelTitle: ''}
      ],
      enumData: [],
    };
  },
  computed:{
    importTypeList() {
      const ENUM_KEY = 'YmsPackageInfoImportTempImportTypeDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    iossTypeList() {
      const ENUM_KEY = 'YmsPackageInfoImportTempIossTypeDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  methods: {
    // 初始化数据
    async initOrderImportTemplateData(type, ymsPackageInfoImportTempId) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003293'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001206')
      };
      this.enumData = await getDataSetBatchList([
        'YmsPackageInfoImportTempImportTypeDistributorEnum',
        'YmsPackageInfoImportTempIossTypeDistributorEnum',
        'YmsPackageInfoImportTempMappingContentTypeDistributorEnum'
      ]);
      this.ymsPackageInfoImportTempId = ymsPackageInfoImportTempId;
      this.orderImportTemplateTitle = obj[type];
      this.orderImportTemplateType = type;
      if (type === 'add') {
        if (this.iossType === 1) {
          this.tableData = this.originalData.filter((item) => {
            return item.columnKey !== 'iossNo';
          });
        } else {
          this.tableData = JSON.parse(JSON.stringify(this.originalData));
        }
        this.tableListScrollsTop('tableDom');
      } else {
        this.getTemplateDetailsData(ymsPackageInfoImportTempId);
      }
      this.orderImportTemplateModal = true;
    },
    // 获取模板详情
    getTemplateDetailsData(ymsPackageInfoImportTempId) {
      let v = this;
      v.axios.get(api.get_ymsPackageInfoImportTemp_queryByImportTempId + ymsPackageInfoImportTempId).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let keyList = ['name', 'importType', 'iossType', 'sameOrderProcessing', 'fileSameOrderProcessing'];
            for (let key of keyList) {
              v[key] = data[key];
            }
            let ymsPackageInfoImportTempMappingList = data.ymsPackageInfoImportTempMappingList || [];
            let sortKeyList = v.originalData.map(item => item.columnKey);
            const newList = ymsPackageInfoImportTempMappingList.sort((a, b) => {
              return sortKeyList.indexOf(a.columnKey) - sortKeyList.indexOf(b.columnKey);
            });
            v.tableData = newList;
            v.originalData.map((item) => {
              ymsPackageInfoImportTempMappingList.map((ele) => {
                if (ele.columnKey === item.columnKey) {
                  item.excelTitle = ele.excelTitle || '';
                }
              });
            });
            // Table列表自动滚动到顶部
            v.tableListScrollsTop('tableDom');
          }
        }
      });
    },
    // 确定按钮
    orderImportTemplateBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      let query = {
        name: v.name,
        importType: v.importType,
        iossType: v.iossType,
        sameOrderProcessing: v.sameOrderProcessing,
        fileSameOrderProcessing: v.fileSameOrderProcessing
      };
      if (!v.name) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000777'));
        return false;
      }
      for (let i = 0; i < v.tableData.length; i++) {
        let item = v.tableData[i];
        if (item.contentType === 1 && !item.excelTitle) {
          let text = item.columnName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006392');
          v.$Message.warning(text);
          return false;
        }
      }

      if (v.orderImportTemplateType === 'add') {
        url = api.post_ymsPackageInfoImportTemp_insertImportTemp;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
        query.ymsPackageInfoImportTempMappings = v.tableData;
      } else if (v.orderImportTemplateType === 'edit') {
        url = api.put_ymsPackageInfoImportTemp_updateImportTemp;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        query.ymsPackageInfoImportTempId = v.ymsPackageInfoImportTempId;
        query.ymsPackageInfoImportTempMappingList = v.tableData;
      }
      v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.orderImportTemplateModal = false;
          v.$Message.success(text);
          v.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    orderImportTemplateChange(value) {
      if (!value) {
        this.name = '';
        this.importType = 1;
        this.iossType = 1;
        this.sameOrderProcessing = 1;
        this.fileSameOrderProcessing = 1;
        this.tableData = [];
        this.originalData.map((item) => {
          item.excelTitle = '';
        });
      }
    }
  },
  watch: {
    iossType: {
      handler(val) {
        if (this.tableData.length > 0) {
          if (val === 1) {
            this.tableData = this.originalData.filter((item) => {
              return item.columnKey !== 'iossNo';
            });
          } else {
            this.tableData = JSON.parse(JSON.stringify(this.originalData));
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.orderImportTemplateStyle /deep/ {
  .ivu-radio-wrapper {
    margin-right: 45px;
  }
}
</style>
